const initialState = {
  events: [],
  error: "",
};

export default initialState;
